module.exports = __webpack_public_path__ + "img/speakr-thumb.f4343987.png";